import React from 'react'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import { getUnitLabel, getPieceLabel, isSuperUnit } from './QuantityPicker'

const fmtVal = (v) => parseFloat(parseFloat(v).toFixed(4)).toString()

function QuantityDisplay({ casePack, uom, value }) {
    const num = parseFloat(value)
    if (isNaN(num) || num === 0) return <span>{isNaN(num) ? '0' : '0'}</span>

    if (!casePack || casePack <= 1) {
        if (isSuperUnit(uom)) {
            return <span>{fmtVal(num)} {getPieceLabel(uom)}</span>
        }
        return <span>{fmtVal(num)}</span>
    }

    const exactPieces = isSuperUnit(uom) ? num : num * casePack
    const totalPieces = Math.round(exactPieces)
    const isRounded = Math.abs(exactPieces - totalPieces) > 0.001

    // Suppress rounding indicator when the difference is caused by 4-decimal
    // precision limitation (e.g. 12/330 stored as 0.0364 → 12.012 sub-units).
    // Check: does truncating the ideal value to 4 decimals reproduce the stored value?
    const isPrecisionArtifact = isRounded && (
        isSuperUnit(uom)
            || Math.abs(num - parseFloat((totalPieces / casePack).toFixed(4))) < 1e-8
    )
    const showIndicator = isRounded && !isPrecisionArtifact
    const units = Math.floor(totalPieces / casePack)
    const pieces = totalPieces % casePack

    const unitLabel = getUnitLabel(uom)
    const pieceLabel = getPieceLabel(uom)
    const formatted = fmtVal(totalPieces / casePack)
    const approxPrefix = showIndicator
        ? <span style={{ fontWeight: 'bold', fontSize: '16px', lineHeight: 1 }}>~</span>
        : null
    const approxDot = showIndicator
        ? <span style={{ display: 'inline-block', width: 6, height: 6, background: '#ffc107', borderRadius: '50%', marginLeft: 4, verticalAlign: 'super' }}></span>
        : null

    const wrapWithTooltip = (content) => {
        if (!showIndicator) return content
        return (
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip>Exact: {exactPieces.toFixed(2)} {pieceLabel}</Tooltip>
                }
            >
                {content}
            </OverlayTrigger>
        )
    }

    // Only units > 0, pieces = 0: just show "5 Cases"
    if (units > 0 && pieces === 0) {
        return wrapWithTooltip(<span>{approxPrefix}{units} {unitLabel}{approxDot}</span>)
    }

    const parts = []
    if (units > 0) parts.push(`${units} ${unitLabel}`)
    if (pieces > 0) parts.push(<React.Fragment key="pieces">{approxPrefix}{pieces} {pieceLabel}</React.Fragment>)
    parts.push(<span key="total">total {formatted} {unitLabel}{approxDot}</span>)

    return wrapWithTooltip(
        <span>
            {parts.map((part, i) => (
                <React.Fragment key={i}>
                    {i > 0 && ', '}
                    {part}
                </React.Fragment>
            ))}
        </span>
    )
}

export default QuantityDisplay
